import type { DeepPartial } from '@luna/utils-ts';

import type { RegularOrders } from '../../types/RegularOrders';

export const regularOrdersFeatureConfigSK: DeepPartial<RegularOrders> = {
    frequencyReadOnly: true,
    postponedUntil: true,
};
